import PropTypes from 'prop-types'
import { Checkbox } from 'components/forms'

const RegistryPreferencesFieldset = ({
  className,
  showMultipleStores,
  priceAndAvailabilityUpdates,
}) => (
  <fieldset className={className}>
    <Checkbox
      {...showMultipleStores}
      label="When possible, automatically show multiple stores that offer an item."
    />

    <Checkbox
      {...priceAndAvailabilityUpdates}
      label="Keep my registry up-to-date with the most recent prices of items"
    />
  </fieldset>
)

RegistryPreferencesFieldset.propTypes = {
  showMultipleStores: PropTypes.object.isRequired,
  priceAndAvailabilityUpdates: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default RegistryPreferencesFieldset
